import React from "react";
import { ManageAIModelSetupsContent } from "../components/AIMaster/ManageAIModelSetupsContent";
import { ToastContainer } from "react-toastify";

export const AIModelSetups = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAIModelSetupsContent />
        </div>
      </div>
    </div>
  );
};
